module.exports = __webpack_public_path__ + "static/media/eternal_clash.octoplay.86728cd2.jpeg";